import { IBurracoSession } from "../../../config/games/burraco/session";
import { IPlayer } from "../../../config/player";

export const extractPlayersFromSession = (session: IBurracoSession): IPlayer[] => {
    return !!session.games.length ? session.games[0].map(g => g.player) : [];
};
